import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, OnDestroy } from '@angular/core';
import { Meta } from '@angular/platform-browser';
// import { Router } from '@angular/router';
// import { filter, pairwise } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TagService implements OnDestroy {

  previousUrl: string;
  constructor(
    @Inject(DOCUMENT) private dom,
    // public _router: Router,
    private meta: Meta,
    ) {
  }
  ngOnDestroy(): void {
    this.resetTags();
  }

  getPrevURL(): string {
    // console.log(this.previousUrl);
    return this.previousUrl;
  }

  setCanonicalURL(url?: string) {
    // console.log('this.dom.URL', this.dom.URL);
    // console.log('URL', url);
    // console.log('canonical set function');
    
    let canURL = url == undefined ? this.dom.URL : url;
    canURL = canURL.split('?')[0];
    let link: HTMLLinkElement = this.dom.querySelector(`link[rel='canonical']`) || null;
    if (link==null) {
      link = this.dom.createElement('link');
      this.dom.head.appendChild(link);
    }
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', canURL);
    this.meta.updateTag({property: 'og:url', content: canURL});
    // console.log('CANONICAL URL:',canURL);
  }

  addTags(product) {
    // console.log(product);
    // console.log(this.meta.getTag('name=description'));
    // <meta property="og:image" content="https://www.veexinc.com/assets/images/header/VeEX_logo_tagline.png">
    if(product.imgsrc){
      let tempimgsrc = product.imgsrc.replace('https://www.veexinc.com', '');
      tempimgsrc = tempimgsrc.replace('./', '/');
      this.meta.updateTag({ property: 'og:image', content: `https://www.veexinc.com${tempimgsrc}` });
      this.meta.updateTag({ name: 'twitter:image', content: `https://www.veexinc.com${tempimgsrc}` });
    } else {
      const tempimgsrc = 'https://www.veexinc.com/assets/images/header/VeEX_logo_tagline.png';
      this.meta.updateTag({ property: 'og:image', content: tempimgsrc });
      this.meta.updateTag({ name: 'twitter:image', content: tempimgsrc });
    }
    this.meta.updateTag({ name: 'title', content: `${product.title} | VeEX Inc.` });
    this.meta.updateTag({ name: 'description', content: `${product["Meta Description"]?product["Meta Description"]:product["text1"]}` });
    this.meta.updateTag({ name: 'keywords', content: `${product.keyword}` });
    this.meta.updateTag({ property: 'og:title', content: `${product.title} | VeEX Inc.` });
    this.meta.updateTag({ property: 'og:description', content: `${product["Meta Description"]?product["Meta Description"]:product["text1"]}` });
    this.meta.updateTag({ property: 'og:keywords', content: `${product.keyword}` });
    this.meta.updateTag({ name: 'twitter:title', content: `${product.title} | VeEX Inc.` });
    this.meta.updateTag({ name: 'twitter:description', content: `${product["Meta Description"]?product["Meta Description"]:product["text1"]}` });
    // console.log(this.meta.getTag('name=keywords'));
  }

  resetTags(){
    const defaulttag = {
      title: 'VeEX Inc. | The Verification EXperts',
      description: 'VeEX Inc., an innovative, customer-focused communications test and measurement company, develops next-generation  test  and  monitoring  solutions  for  telecommunication  networks  and  services.  With  a  blend  of advanced technologies and vast technical expertise, VeEX has developed products that diligently address all stages  of  network  deployment,  maintenance,  and  field  service  turn-up  and  integrate  service  verification features across DSL, fiber optics, CATV/DOCSIS, mobile backhaul and fronthaul (CPRI/OBSAI), next-generation transport network, fiber channel, carrier and metro Ethernet technologies, WLAN, and synchronization.',
      keywords: 'test and measurement testing telecom data center datacom Communications vesion fiberizer desktop otdr power meter cabletv ethernet transport wifi fiber optics nem docsis 400g 100g 10g network test equipment software download rtu rxt veex veexinc',
      imgsrc: 'https://www.veexinc.com/assets/images/header/VeEX_logo_tagline.png'
    };

    const link: HTMLLinkElement = this.dom.querySelector(`link[rel='canonical']`) || null;
    if(link){
      this.dom.head.removeChild(link);
      this.setCanonicalURL();
    }

    let tempimgsrc = defaulttag.imgsrc.replace('https://www.veexinc.com', '');
    tempimgsrc = tempimgsrc.replace('./', '/');
    this.meta.updateTag({ property: 'og:image', content: `https://www.veexinc.com${tempimgsrc}` });
    this.meta.updateTag({ name: 'twitter:image', content: `https://www.veexinc.com${tempimgsrc}` });
    this.meta.updateTag({ name: 'title', content: defaulttag.title });
    this.meta.updateTag({ name: 'description', content: defaulttag.description });
    this.meta.updateTag({ name: 'keywords', content: defaulttag.keywords });
    this.meta.updateTag({ property: 'og:title', content: defaulttag.title });
    this.meta.updateTag({ property: 'og:description', content: defaulttag.description });
    this.meta.updateTag({ property: 'og:keywords', content: defaulttag.keywords });
    this.meta.updateTag({ name: 'twitter:title', content: defaulttag.title });
    this.meta.updateTag({ name: 'twitter:description', content: defaulttag.description });
  }
}
